import NotFoundErrorView from 'features/errors/NotFoundErrorView';

const NotFoundPage = () => <NotFoundErrorView />;

export default NotFoundPage;
